import { useMutation } from 'react-query';
import UserGroups from '../../services/UserGroups';

export const useRegisterStripeReader = () =>
  useMutation(({ registrationCode, medspaLocationId }: { medspaLocationId: number; registrationCode: string }) =>
    UserGroups.registerStripeReader(registrationCode, medspaLocationId)
  );
